<template>
  <div v-loading="loading" style="flex:auto;margin:0 10px;position:relative;">
    <div v-if="onkeyMatchMode != '智能' && searchReady" class="radish-search">
      <div style="background:#fff;border-radius:4px;margin-top:5px;padding:10px;">
        <div
          v-for="i in 8" :key="searchFields[searchOrder[i - 1]].label + 's'"
          :style="{ width: searchFields[searchOrder[i - 1]].width }"
          style="position:relative;display: inline-block;"
        >
          <!-- todo行业库 -->
          <!-- <div v-if="searchOrder[i - 1]=='行业'" title="行业:"
            class="form-item form-item-inline"
            style="width: 50%; padding-left: 60px; background-color: #fff;display:inline-flex;position:relative">
            <label style="width: 60px;"> 行业:</label>
            <el-select v-model="ranges.行业" size="mini" style="width:120px">
              <el-option label="目前" value="行业"></el-option>
              <el-option label="过往" value="全部行业"></el-option>
            </el-select>
          </div> -->
          <div v-if="searchOrder[i - 1]=='人员背景'" title="人员背景:"
            class="form-item form-item-inline"
            style="width: 100%; padding-left: 60px; background-color: #fff;display:inline-flex;position:relative">
            <label style="width: 60px;"> 人员背景:</label>
            <el-cascader
              v-model="searchData[searchFields[searchOrder[i - 1]].label]"
              :options="searchFields[searchOrder[i - 1]].options"
              :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
              :show-all-levels="false"
              :collapse-tags="true"
              size="mini"
              style="width:100%">
            </el-cascader>
          </div>
          <template v-else>
            <formItem
              :type="searchFields[searchOrder[i - 1]].type"
              :is-inline="true"
              width="100%"
              :isRequired="searchOrder[i - 1]=='职能模块' && onkeyMatchMode != '智能'"
              :label-width="searchFields[searchOrder[i - 1]].labelWidth"
              :label="searchFields[searchOrder[i - 1]].label"
              :display-label="searchFields[searchOrder[i - 1]].displayLabel"
              :collapse-tags="true"
              :options="searchFields[searchOrder[i - 1]].options"
              :content="searchData[searchFields[searchOrder[i - 1]].label]"
              :handle-data-change="handleSearchChange"
              @keyup-enter.stop="handleSearch"
            ></formItem>
            <div
              v-if="searchOrder[i - 1]=='职能模块'"
              class="ku-item"
              @click="showSelectFunction"
            >
              <i class="el-icon-info" style="margin-right:2px" />职能库
            </div>
            <div
              v-if="searchOrder[i - 1]=='地域'"
              @click="toChooseCity('地域')"
              style="cursor:pointer;height:26px;line-height:26px;font-size:24px;position:absolute;right:10px;top:2px;background:#fff"
            >
              <i class="el-icon-folder-opened" style="color:#409eff" />
            </div>
          </template>
        </div>
        <template v-for="cateField in cateFields">
          <formItem
            v-if="cateField"
            :key="cateField.label"
            :type="cateField.type"
            :is-inline="true"
            :width="cateField.width"
            :label-width="cateField.labelWidth"
            :label="cateField.label"
            :display-label="cateField.displayLabel"
            :options="cateField.options"
            :content="searchData[cateField.label]"
            :handle-data-change="handleSearchChange"
            @keyup-enter.stop="handleSearch"
          ></formItem>
        </template>
        <div>
          <el-tag size="small" effect="plain" style="cursor:pointer;margin-right:30px" @click="showSelectCompany('勿推公司')">
            勿推企业
            <el-tooltip effect="dark" content="勿推企业：本次搜索系统将不会匹配出您设置的公司" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-tag>
          <el-checkbox v-model="isXuekuUp">
            血库置顶
            <span class="el-icon-view" style="color:#F56C6C;margin-left:3px"></span>
          </el-checkbox>
          <el-checkbox v-model="isNoShuangfei">过滤双非学历</el-checkbox>
          <span style="margin-left:150px">
            <el-button
              v-if="searchMode == 'simple'"
              icon="el-icon-arrow-down"
              type="text"
              size="mini"
              @click="setMode('complete')"
              >更多搜索项</el-button
            >
            <el-button
              v-else
              icon="el-icon-arrow-down"
              type="text"
              size="mini"
              @click="setMode('simple')"
              >收起更多搜索项</el-button
            >
          </span>
        </div>
        <div v-if="searchMode == 'complete'">
          <template v-for="i in searchOrder.length - 8">
            <div v-if="searchOrder[i + 7]=='公司'" title="公司:"
              class="form-item form-item-inline"
              style="width: 50%; padding-left: 60px; background-color: #fff;display:inline-flex;position:relative">
              <label style="width: 60px;"> 公司:</label>
              <el-autocomplete
                v-model="companyKeyword"
                size="mini"
                :fetch-suggestions="searchCompany"
                placeholder="请输入公司名称（多个公司用空格区分）"
                @input="addKeywordTag('公司', companyKeyword)"
              >
                <template slot-scope="{ item }">
                  <span v-if="item.highlight" class="keyword-item" v-html="item.highlight"></span>
                  <span v-else> <i class="el-icon-time"></i> &nbsp;{{ item.value }} </span>
                </template>
              </el-autocomplete>
              <div
                class="ku-item"
                style="right:90px"
                @click="showSelectCompany('公司')"
              >
                <i class="el-icon-info" style="margin-right:5px" />公司库
              </div>
              <el-select v-model="ranges.公司" size="mini" style="width:100px">
                <el-option label="全部" value="目标公司"></el-option>
                <el-option label="当前" value="公司"></el-option>
                <el-option label="曾任职" value="曾任职公司"></el-option>
              </el-select>
            </div>
            <div v-else-if="searchOrder[i + 7]=='毕业院校'" title="毕业院校:"
              class="form-item form-item-inline"
              style="width: 50%; padding-left: 60px; background-color: #fff;display:inline-flex;position:relative">
              <label style="width: 60px;"> 毕业院校:</label>
              <el-select
                v-model="school"
                size="mini"
                multiple
                collapse-tags
                filterable
                remote
                :remote-method="searchSchool"
                :loading="schoolLoading"
                placeholder="请输入学校名称"
                class="radish-search-select"
                @change="handleSearchChange({label:'毕业院校', content:school})"
              >
                <el-option v-for="item in schoolRes" :key="item.value" :label="item.value" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="ranges.毕业院校" size="mini" style="width:120px">
                <el-option label="全部" value="学校"></el-option>
                <el-option label="只搜本科" value="本科院校"></el-option>
                <el-option label="只搜硕士" value="硕士院校"></el-option>
              </el-select>
            </div>
            <formItem
              v-else-if="searchFields[searchOrder[i + 7]]"
              :key="searchFields[searchOrder[i + 7]].label + 's'"
              :type="searchFields[searchOrder[i + 7]].type"
              :is-inline="true"
              :width="searchFields[searchOrder[i + 7]].width"
              :label-width="searchFields[searchOrder[i + 7]].labelWidth"
              :label="searchFields[searchOrder[i + 7]].label"
              :display-label="searchFields[searchOrder[i + 7]].displayLabel"
              :collapse-tags="true"
              :options="searchFields[searchOrder[i + 7]].options"
              :content="searchData[searchFields[searchOrder[i + 7]].label]"
              :handle-data-change="handleSearchChange"
              @keyup-enter.stop="handleSearch"
            ></formItem>
          </template>
        </div>
      </div>
      <div style="display:flex;background:#fff;border-radius:4px;margin-top:5px;padding:5px 10px;border: 2px solid #fff"
        :style="{ borderColor:radishes.length>0?'#fff':'#f99'}">
        <div style="flex:1;display:flex;justify-content:space-between;">
          <div class="arrow-slider">
            <span style="flex:none">已选：</span>
            <div v-if="showLeft.yixuan" class="arrow-slider-arrow" @click="slideLeft('yixuan')">
              <i class="el-icon-caret-left"></i>
            </div>
            <div class="arrow-slider-tags" style="width:560px">
              <div class="arrow-slider-inner" id="yixuan" :style="{left:left.yixuan+'px'}">
                <el-tag v-for="(tag, k) in yixuan" size="small" type="info" :key="k+tag" closable disable-transitions @close="removeTag(tag)">
                  {{ tag.label }}
                </el-tag>
              </div>
            </div>
            <div v-if="showRight.yixuan" class="arrow-slider-arrow" @click="slideRight('yixuan')">
              <i class="el-icon-caret-right"></i>
            </div>
          </div>
          <div class="arrow-slider">
            <span style="flex:none">勿推：</span>
            <div v-if="showLeft.wutui" class="arrow-slider-arrow" @click="slideLeft('wutui')">
              <i class="el-icon-caret-left"></i>
            </div>
            <div class="arrow-slider-tags" style="width:240px">
              <div class="arrow-slider-inner" id="wutui" :style="{left:left.wutui+'px'}">
                <el-tag v-for="(tag, k) in wutui" :key="k+tag" size="small" type="danger" closable disable-transitions @close="removeWutui(tag)">
                  {{ tag }}
                </el-tag>
              </div>
            </div>
            <div v-if="showRight.wutui" class="arrow-slider-arrow" @click="slideRight('wutui')">
              <i class="el-icon-caret-right"></i>
            </div>
          </div>
        </div>
        <div style="flex:none">
          <el-button type="primary" size="mini" round @click="handleSearch" style="margin:0 5px">搜索</el-button>
          <el-button size="mini" round @click="cleanSearch">清空</el-button>
        </div>
      </div>
    </div>
    <div v-show="radishes.length == 0" style="margin:10px 0;padding-top:70px;background:#fff;">
      <div style="position:relative;width:400px;margin:0 auto;text-align:right;">
        <div
          class="el-popover el-popper el-popover--plain"
          style="width: 260px; position: absolute; top: -50px; left: -50px; transform-origin: center bottom;"
          x-placement="top"
        >
          <span style="color:#888">小阿没有为您找到匹配的人选，不妨放开一些条件试试</span>
          <div class="popper__arrow" style="left: 200px;"></div>
        </div>
        <img src="../../assets/images/xiaoa.png" style="width:300px">
      </div>
    </div>
    <div v-show="radishes.length > 0" ref="radishTableWapper" style="background:#fff;border-radius:4px;margin-top:5px;padding:0 10px">
      <a-table
        ref="radishTable"
        :data="displayRadishes"
        :heads="tableHeads"
        :height="tableHeight"
        :active-row-id="activeRowId"
        :storage-name="storageName"
        :start="limit * (page - 1)"
        :on-set-hidden-cell="setHiddenCell"
        :on-set-cell-order="setCellOrder"
      >
      </a-table>
    </div>
    <div style="position:fixed;bottom:5px;width:80%;left:20%;padding:0 20px">
      <div style="background:#fff;border-radius:4px;height:38px;line-height:38px;padding-left:10px;border:1px solid #eee;box-shadow:0 2px 12px 0 rgb(0 0 0 / 10%)">
        <span style="margin-right:10px">
          共搜索到：{{ total }} 人
          <span v-show="xuekuNum">，其中 {{ xuekuNum }} 人为血库公司人选</span>
          <span v-show="grayNum">，{{ grayNum }}人已加入项目灰色标记</span>
        </span>
        <span style="margin-right:10px;color:#F7BD81">已选择{{ selectedNum }}人</span>
      </div>
      <div style="text-align:center;position:absolute;top:5px;left:0;right:0">
        <el-button size="mini" v-show="selectedNum" type="primary" :disabled="joinProjectPending" @click="joinProject">加入项目</el-button>
      </div>
    </div>
    <Popper id="radish-popper" :visible.sync="popperVisible" :target-id="popperTarget">
      <div class="radish-pop">
        <AttachmentsType
          v-if="popperContent == 'files'"
          :attach="files"
          :rid="popperTarget && popperTarget.replace('附件', '')"
          :paginate="false"
          :on-delete="deleteAttachment"
          :width="600"
          :height="300"
        />
        <span v-if="popperContent == 'action'">
          <el-button size="mini" @click="showIntoProject(false)">加入项目</el-button>
          <el-button v-if="currentRow['手机']" size="mini" @click="showRecommend(false)">推荐</el-button>
          <el-button size="mini" @click="uploadCv()">上传简历</el-button>
          <el-button size="mini" @click="uploadReport()">上传推荐报告</el-button>
          <el-button size="mini" @click="genRepo">生成推荐报告</el-button>
          <el-button size="mini" @click="showRadishPortrait">人才画像</el-button>
        </span>
        <div v-if="popperContent == 'bulletin'">
          <el-table :data="bulletins" border size="mini" :resizable="false" style="width: 600px; height: 200px">
            <el-table-column
              v-for="head in bulletinHeads"
              :key="head.label"
              :prop="head.label"
              :label="head.label"
              :width="head.width"
            ></el-table-column>
          </el-table>
        </div>
        <workExp
          v-if="popperContent == 'comExp'"
          ref="workExp"
          :radish="currentRow"
          :on-close="onCloseWorkexp"
        ></workExp>
      </div>
    </Popper>
    <conditionDialog ref="conditionDialog"></conditionDialog>
    <editDialog ref="editDialog" :on-confirm="loadData"></editDialog>
    <cateDialog ref="cateDialog" :on-confirm="loadData"></cateDialog>
    <explainDialog ref="explainDialog" :on-confirm="loadData"></explainDialog>
    <departmentDialog ref="departmentDialog" :on-confirm="loadData"></departmentDialog>
    <UploadDialog ref="UploadDialog" :type="uploadType" :label="attachType" :on-success="uploadSuccess"></UploadDialog>
    <interviewListDialog ref="interviewListDialog"></interviewListDialog>
    <SelectFunction ref="SelectFunction" @confirm="addFunction"></SelectFunction>
  </div>
</template>
<script>
import { Popper } from '../../project'
import conditionDialog from './dialog/condition-dialog'
import editDialog from './dialog/edit-dialog'
import cateDialog from './dialog/cate-dialog'
import explainDialog from './dialog/explain-dialog'
import departmentDialog from './dialog/department-dialog'
import { FileTable, UploadDialog } from '../../file'
import { searchFieldsOnekey, cateFieldOnekey, cateFieldMap } from './constant/searchFieldsOnekey'
import tableHeads from './constant/table-heads'
import bulletinHeads from './constant/bulletin-heads'
import methodsList from './constant/methods-list'
import aList from './table/a-list'
import workExp from './components/work-exp'
import interviewListDialog from './dialog/interviewlist-dialog'
import AttachmentsType from './components/attachments-type'
import SelectFunction from '../../company/src/hunting/selectFunction'
import { radishScore } from '../../project/src/constant/utils.js'

export default {
  components: {
    aList,
    FileTable,
    conditionDialog,
    editDialog,
    cateDialog,
    explainDialog,
    UploadDialog,
    departmentDialog,
    workExp,
    Popper,
    interviewListDialog,
    AttachmentsType,
    SelectFunction
  },
  mixins: [tableHeads, bulletinHeads, methodsList],
  props: {
    pid: String,
    ids: Array,
    onkeyMatchMode: String,
    onConfirm: Function,
  },
  data: function() {
    return {
      loading: false,
      searchReady: false,
      catData: [],
      radishes: [],
      displayRadishes: [],
      existsRid: {},
      query: {},
      total: 0,
      page: 1,
      limit: 301,
      multipleSelection: [],
      searchFields: searchFieldsOnekey,
      searchOrder: [],
      searchData: { 年龄: [0, 55] },
      searchMode: 'simple',
      yiOptions: ['Y', 'N', 'F'],
      defaultProject: {},
      tableHeight: 600,
      filesVisible: false,
      actionVisible: false,
      files: [],
      currentRow: {},
      popperVisible: false,
      popperContent: '',
      popperTarget: '',
      storageName: 'radishHeads',
      attachType: '',
      uploadType: '',
      bulletins: [],
      yixuan: [],
      wutui: [],
      cateFields: {},
      ranges: {
        行业: '行业',
        公司: '目标公司',
        毕业院校: '学校',
      },
      companyKeyword: '',
      school: [],
      companyRes: [],
      schoolRes: [],
      goodSchools: [],
      defSchool: [
        { value: '清华大学' },
        { value: '北京大学' },
        { value: '复旦大学' },
        { value: '上海交通大学' },
        { value: '浙江大学' },
        { value: '南京大学' },
        { value: '中国人民大学' },
        { value: '武汉大学' },
        { value: '南开大学' },
      ],
      schoolLoading: false,
      xueku: [],
      xuekuNum: 0,
      grayNum: 0,
      joinProjectPending: false,
      showLeft: {
        yixuan: false,
        wutui: false,
      },
      showRight: {
        yixuan: false,
        wutui: false,
      },
      left: {
        yixuan: 0,
        wutui: 0,
      },
      isXuekuUp: false,
      isNoShuangfei: false,
    }
  },
  computed: {
    isAdmin() {
      return app.user['角色'] && app.user['角色'].includes('管理员')
    },
    activeRowId() {
      return this.currentRow._id
    },
    selectedNum() {
      return this.displayRadishes.filter(dt => dt.checkedRow).length
    },
  },
  watch: {
    pid: async function() {
      await this.loadProRadish()
      this.loadData()
    },
    isXuekuUp() {
      this.setDisplayData()
    },
    isNoShuangfei() {
      this.setDisplayData()
    },
  },
  beforeMount() {
    window.addEventListener('resize', this.resetTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resetTableHeight)
  },
  methods: {
    init: async function() {
      await this.loadCate()
      await this.initXueku()
      await this.loadProRadish()
      await this.loadSchool()
      this.searchOrder = Object.keys(this.searchFields)
      this.searchReady = true
      // console.log(this.searchOrder)
      this.setHiddenCell('donotLoadData')
      this.setCellOrder()
      this.$nextTick(() => {
        this.resetTableHeight()
      })
    },
    loadData: async function() {
      // let start = Date.now()
      this.loading = true
      let res = {}
      const query = this.mapQuery()
      // console.log('q', query)
      this.loading = true
      const postData = {
        query: query,
        $page: this.page,
        $limit: this.limit,
        $sort: {
          公司排名: 1,
          公司: -1,
          部门: -1,
          职级: 1,
          createdAt: -1,
        },
      }
      res = await app.service('radish').listOnekey(postData)
      if (res.status === 'success') {
        this.total = res.data.data.length > 300 ? '300+' : res.data.data.length
        let xuekuNum = 0
        let grayNum = 0
        if (res.data.data.length > 300) res.data.data.pop()
        const radishes = res.data.data.map(dt=>{
          dt.checkedRow = false
          if (dt.公司 && this.xueku.find(xk=>xk.简称 == dt.公司)) {
            dt.isXueku = true
            xuekuNum ++
          }
          if (this.existsRid[dt._id]) {
            dt.disable = true
            grayNum ++
          }
          return dt
        })
        this.xuekuNum = xuekuNum
        this.grayNum = grayNum
        radishes.sort((next, curr) => {
          return !next.disable && curr.disable ? -1 : 1
        })
        this.radishes = radishes
        this.displayRadishes = JSON.parse(JSON.stringify(this.radishes))
        // console.log(this.radishes);
        this.$nextTick(function() {
          this.$refs.radishTable.setDisplay(true)
          this.resetTableHeight()
        })
        this.$emit('onLoaded', this.radishes)
      } else {
        console.error(res)
      }
      // let end = Date.now()
      this.loading = false
    },
    mapQuery: function() {
      const query = JSON.parse(JSON.stringify(this.query))
      if (query.年龄 && query.年龄[0] == 0 && query.年龄[1] == 55) delete query.年龄
      Object.keys(this.ranges).forEach(field=>{
        const val = query[field]
        if (val && this.ranges[field] != field) {
          query[this.ranges[field]] = val
          delete query[field]
        }
      })
      if (this.wutui.length > 0) {
        query.勿推公司 = this.wutui
      }
      return query
    },
    async loadProRadish() {
      const existProjectRadishes = await app.service('project').radishProject({
        query: {
          pid: this.pid,
          isDeleted: { $in: [false, null] },
        },
      })
      const existsRid = {}
      existProjectRadishes.forEach(projectRadish => {
        existsRid[projectRadish.rid] = true
      })
      this.existsRid = existsRid
      // console.log('existsRid', existsRid)
    },
    async loadSchool() {
      const res = await app.service('radish').getGoodSchools()
      if (res.status == 'success') {
        this.goodSchools = res.data
      }
      // console.log('loadSchool', res)
    },
    loadOne: async function(id) {
      let res = await app.service('radish').fetch({ _id: id })
      if (res.status == 'success') {
        let dt = res.data[0]
        this.radishes = this.radishes.map(rad => {
          if (rad._id == id) {
            rad = dt
          }
          return rad
        })
        this.displayRadishes = this.displayRadishes.map(rad => {
          if (rad._id == id) {
            rad = dt
          }
          return rad
        })
        // console.log(dt)
        this.$nextTick(() => {
          this.$refs.radishTable.setDisplay(true)
        })
      }
    },
    getPhone: async function(id) {
      const res = await app.service('radish').simpleFetch({ _id: id, fields: { 手机: 1 } })
      if (res.status == 'success') {
        this.radishes.forEach(rad => {
          if (rad._id == id) {
            rad.手机 = res.data.手机
          }
        })
        this.displayRadishes.forEach(rad => {
          if (rad._id == id) {
            rad.手机 = res.data.手机
          }
        })
      }
    },
    getGou: async function(id) {
      const res = await app.service('radish').simpleFetch({ _id: id, fields: { 沟通日志: 1 } })
      if (res.status == 'success') {
        this.radishes.forEach(rad => {
          if (rad._id == id) {
            rad.沟通日志 = res.data.沟通日志
          }
        })
        this.displayRadishes.forEach(rad => {
          if (rad._id == id) {
            rad.沟通日志 = res.data.沟通日志
          }
        })
      }
    },
    setYixuan() {
      if (!this.searchData) return []
      const res = []
      Object.keys(this.searchData).forEach(field=>{
        const val = this.searchData[field]
        if (field == '勿推公司') {
          this.wutui = val
        } else if (field == '年龄') {
          if (!(val[0]===0 && val[1]===55) && !res.find(r=>r.field == '年龄')) {
            res.push({ field: '年龄', value: val, label: `${val[0]}-${val[1]}` })
          }
        } else if (Array.isArray(val)) {
          val.forEach(v => {
            let label = v
            if (searchFieldsOnekey[field] && searchFieldsOnekey[field].options && !Array.isArray(searchFieldsOnekey[field].options)) {
              label = searchFieldsOnekey[field].options[`${v}`]
            } else if (cateFieldOnekey[field] && cateFieldOnekey[field].options && !Array.isArray(cateFieldOnekey[field].options)) {
              label = searchFieldsOnekey[field].options[`${v}`]
            }
            res.push({ field, value: v, label })
          })
        } else if (field != 'progress') {
          let label = val
          if (searchFieldsOnekey[field] && searchFieldsOnekey[field].options && !Array.isArray(searchFieldsOnekey[field].options)) {
            label = searchFieldsOnekey[field].option[`${val}`]
          } else if (cateFieldOnekey[field] && cateFieldOnekey[field].options && !Array.isArray(cateFieldOnekey[field].options)) {
            label = searchFieldsOnekey[field].options[`${val}`]
          }
          res.push({ field, value: val, label })
        }
      })
      this.yixuan = res
      this.$nextTick(()=>{
        this.setShowLeft('yixuan')
        this.setShowRight('yixuan')
      })
    },
    setCateFields() {
      if (!this.searchData.职能模块 || this.searchData.职能模块.length == 0) return {}
      const res = {}
      this.searchData.职能模块.forEach(cate => {
        if (cate.indexOf('医疗-') !== -1) {
          res['医疗背景'] = cateFieldOnekey['医疗背景']
          res['医疗科室'] = cateFieldOnekey['医疗科室']
        } else if (cate.indexOf('芯片') !== -1) {
          res['是否量产'] = cateFieldOnekey['是否量产']
          res['是否流片'] = cateFieldOnekey['是否流片']
        } else if (cate.indexOf('猎头') !== -1) {
          res['擅长职能'] = cateFieldOnekey['擅长职能']
          res['团队业绩'] = cateFieldOnekey['团队业绩']
          res['开票业绩'] = cateFieldOnekey['开票业绩']
          res['擅长职位'] = cateFieldOnekey['擅长职位']
          res['客户资源'] = cateFieldOnekey['客户资源']
          res['客户资源'].options = app.kehuziyuanOpt || []
        } else if (cate.indexOf('工业-') !== -1) {
          res['业务方向'] = cateFieldOnekey['业务方向']
        } else if (cateFieldMap[cate]) {
          cateFieldMap[cate].forEach(field=>{
            res[field] = cateFieldOnekey[field]
          })
        }
      })
      this.cateFields = res
    },
    handleSelectionChange: function(val) {
      // console.log(val)
      this.multipleSelection = val
    },
    handleSearchChange: function(res) {
      const { label, content } = res
      this.searchData[label] = content
      this.setYixuan()
      if (label == '职能模块' && content) {
        this.searchReady = false
        const currentCat = this.catData.filter(cat => content.includes(cat['名称']))
        if (currentCat.length > 0) {
          const cat = currentCat[0]
          if (cat['二级职能'] && cat['二级职能'].length > 0) {
            const znArr = cat['二级职能']
            this.searchFields['细分职能'].options = znArr.concat('空')
          } else {
            this.searchFields['细分职能'].options = []
          }
          if (cat['擅长方向'] && cat['擅长方向'].length > 0) {
            const scArr = cat['擅长方向']
            this.searchFields['擅长方向'].options = scArr.concat('空')
          } else {
            this.searchFields['擅长方向'].options = []
          }
        } else {
          this.searchFields['细分职能'].options = []
          this.searchFields['擅长方向'].options = []
        }
        this.searchFields['专业职级'].options = content && content.includes('HH-猎头') ? ['R', 'AC', 'C', 'SC', 'PC', 'TL\M', 'SM', 'AD', 'D', 'AP', 'P', 'SP', 'Office Head', 'GM', 'CEO'] : ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
        this.setCateFields()
        this.searchReady = true
      }
    },
    handleSearch: async function() {
      const sdt = JSON.parse(JSON.stringify(this.searchData))
      const query = {}
      if (this.query['手机'] == '空' || this.query['手机'] == '非空') {
        query['手机'] = this.query['手机']
      }
      for (const field in sdt) {
        const val = sdt[field]
        if (val && val.length > 0) {
          query[field] = val
        }
      }

      this.query = query
      // console.log('searchData',sdt)
      this.page = 1
      await this.loadData()
      this.setMode('simple')
      // localStorage.radishSearchData = sdtStr
    },
    cleanSearch: function() {
      this.searchReady = false
      // console.log('clean1',this.searchData)
      this.searchData = { 年龄: [0, 55] }
      // this.handleSearch()
      this.wutui = []
      this.yixuan = []
      this.radishes = []
      this.displayRadishes = []
      this.total = 0
      this.xuekuNum = 0
      // console.log('clean',this.searchData)
      this.searchReady = true
      // localStorage.removeItem('radishSearchData')
    },
    onCloseWorkexp: function() {
      this.popperVisible = false
    },
    async showRadishPortrait() {
      await app.service('project').saveRecords({ type: '人才画像', path: '条件搜索', page: '人才' })
      app.root.$refs.RadishPortrait.open({ rid: this.currentRow._id })
    },
    onSearchFieldsConfirm() {
      console.info('esSearchSelect')
    },
    clickStatus: function(item) {
      this.$refs.interviewListDialog.show(item)
    },
    closeFav() {
      this.$parent.setCurrentFav({})
    },
    removeTag(tag) {
      this.yixuan = this.yixuan.filter(y=>!(y.field == tag.field && y.label == tag.label))
      const searchVal = this.searchData[tag.field]
      if (tag.field == '年龄') {
        this.searchData[tag.field] = [0, 55]
      } else if (typeof searchVal == 'string') {
        delete this.searchData[tag.field]
      } else {
        this.searchData[tag.field] = searchVal.filter(s=>s != tag.value)
      }
      this.$nextTick(()=>{
        this.setShowLeft('yixuan')
        this.setShowRight('yixuan')
      })
    },
    removeWutui(tag) {
      this.wutui = this.wutui.filter(w=>w != tag)
      this.$nextTick(()=>{
        this.setShowLeft('wutui')
        this.setShowRight('wutui')
      })
    },
    showSelectFunction() {
      this.$refs.SelectFunction.open()
    },
    addFunction(func) {
      if (!func || func.length == 0) return
      const obj = {}
      func.forEach(item => {
        Object.keys(item).forEach(field=>{
          if (field == '名称') {
            if (!obj['职能模块']) obj['职能模块'] = []
            obj['职能模块'].push(item[field])
          } else {
            if (!obj[field]) obj[field] = []
            obj[field] = Array.from(new Set(obj[field].concat(item[field])))
          }
        })
      })
      // console.log('addFunction', func, obj)
      Object.keys(obj).forEach(label=>{
        let content = obj[label]
        if (this.searchData[label] && this.searchData[label].length > 0) {
          content = Array.from(new Set(obj[label].concat(this.searchData[label])))
        }
        // console.log(label, content)
        this.handleSearchChange({ label, content })
      })
    },
    addKeywordTag(fieldName, str) {
      str = (str || '').trim()
      if (!str) {
        this.handleSearchChange({ label: fieldName, content: null })
      } else {
        const arr = str.split(/\s+/)
        this.handleSearchChange({ label: fieldName, content: arr })
      }
    },
    async createFilter(keywords, fields) {
      this.keywordsLoading = true
      const arr = keywords.split(/\s+/)
      const keyword = arr.pop()
      const highlight = arr.join(' ')
      const q = { keyword }
      if (fields) q.fields = fields
      let res
      try {
        res = await app.service('radish').listKeywords(q)
        this.keywordsLoading = false
        if (res.status == 'success') {
          return res.data.map(dt => {
            const item = {
              value: highlight ? `${highlight} ${dt.keyword}` : dt.keyword,
              highlight: `<span>${highlight}</span>${highlight ? ' ' : ''}${dt.keyword.replace(
                keyword,
                `<span>${keyword}</span>`,
              )}`,
            }
            return item
          })
        }
      } catch (e) {
        this.keywordsLoading = false
        console.error(e)
      }
      return []
    },
    async searchCompany(queryString, cb) {
      const keywords = (queryString || '').trim()
      if (keywords !== queryString || this.keywordsLoading) {
        cb(this.companyRes)
      } else {
        this.companyRes = await this.createFilter(keywords, ['公司'])
        cb(this.companyRes)
      }
    },
    async searchSchool(queryString) {
      const keywords = (queryString || '').trim()
      if (!keywords || this.schoolLoading) {
        this.schoolRes = this.defSchool
      } else {
        this.schoolLoading = true
        const res = await app.service('misc').getSchoolSuggestion({ school: keywords })
        if (res.status == 'success') {
          this.schoolRes = res.data.map(v => ({ value: v.name, label: v.name }))
        }
      }
      this.schoolLoading = false
    },
    showSelectCompany(field) {
      if (field == '勿推公司') {
        app.root.$refs.selectCompany.open(this.searchData.勿推公司, (coms) => {
          if (!coms || coms.length == 0) return
          this.wutui = coms
          this.$nextTick(()=>{
            this.setShowLeft('wutui')
            this.setShowRight('wutui')
          })
        }, true)
      } else {
        app.root.$refs.selectCompany.open(this.companyKeyword.split(' ').filter(Boolean), (coms) => {
          if (!coms || coms.length == 0) return
          this.handleSearchChange({ label: '公司', content: coms })
          this.companyKeyword = coms.join(' ')
        })
        if (field == '血库') {
          app.root.$refs.selectCompany.curIndustry = '公募基金'
          this.$nextTick(()=>{
            app.root.$refs.selectCompany.onlyXueKu = true
          })
        }
      }
    },
    async initXueku() {
      const res1 = await app.service('company').getCompanySituation({行业:'公募基金'})
      const res2 = await app.service('company').getCompanySituation({行业:'证券'})
      const data = res1.data.concat(res2.data)
      const xueku = []
      for (let dt of data) {
        let xuekuScore = 1
        let jinzhuScore = 1
        let sum = 40
        const companyInfo = dt.companyInfos && dt.companyInfos[0]
        Object.keys(dt.血库).forEach((xk) => {
          xuekuScore *= dt.血库[xk].标准分
        })
        Object.keys(dt.金主).forEach((jz) => {
          jinzhuScore *= dt.金主[jz].标准分
        })
        let jinzhuBaifenshu = (jinzhuScore / sum).toFixed(4) * 100
        let xuekuScoreBaifenshu = (xuekuScore / sum).toFixed(4) * 100
        dt.显示百分数 = Math.max(jinzhuBaifenshu, xuekuScoreBaifenshu)
        if (dt.显示百分数 < 60) continue
        dt.金主百分数 = jinzhuBaifenshu
        dt.血库百分数 = xuekuScoreBaifenshu
        if (companyInfo) {
          dt.显示百分数 = companyInfo.可信程度 * 100
          if (companyInfo.类别 === '金主') {
            dt.金主百分数 = dt.显示百分数
          } else {
            dt.血库百分数 = dt.显示百分数
          }
        }
        dt.简称 = dt.简称 || ''
        if (dt.血库百分数 >= dt.金主百分数) {
          xueku.push(dt)
        }
      }
      // console.log('xueku', xueku)
      this.xueku = xueku
    },
    setShowLeft(type) {
      const el = document.getElementById(type)
      const len = (type == 'yixuan') ? 560 : 240
      if (el && el.offsetWidth <= len) {
        this.left[type] = 0
      }
      this.showLeft[type] = this.left[type] < 0
      // console.log(1,type, this.left[type], el && el.offsetWidth, this.showLeft[type])
    },
    setShowRight(type) {
      const el = document.getElementById(type)
      const len = (type == 'yixuan') ? 560 : 240
      this.showRight[type] = el && el.offsetWidth > len && (this.left[type] + el.offsetWidth > len)
      // console.log(2,type, this.left[type], el && el.offsetWidth, this.showRight[type])
    },
    slideLeft(type) {
      const el = document.getElementById(type)
      const left = this.left[type]
      const len = (type == 'yixuan') ? 560 : 240
      this.left[type] = -left <= len ? 0 : left + len
      this.$nextTick(()=>{
        this.setShowLeft(type)
        this.setShowRight(type)
      })
      // console.log(3,type,left)
    },
    slideRight(type) {
      const el = document.getElementById(type)
      const left = this.left[type]
      const width = el.offsetWidth
      const len = (type == 'yixuan') ? 560 : 240
      this.left[type] = (len + left + len) >= width + left ? len - width : left - len
      this.$nextTick(()=>{
        this.setShowLeft(type)
        this.setShowRight(type)
      })
      // console.log(4,type,left, width)
    },
    resetTableHeight() {
      const el = this.$refs.radishTableWapper
      el && (this.tableHeight = document.documentElement.clientHeight - el.offsetTop - 200)
      // console.log('resetTableHeight', this.tableHeight)
    },
    async joinProject() {
      if (this.joinProjectPending) return
      this.joinProjectPending = true
      const { pid, onkeyMatchMode } = this
      try {
        const selected = this.$refs.radishTable.getChecked() || []
        if (selected.length === 0) return (this.joinProjectPending = false)
        const data = selected.map(radish => {
          const rid = radish._id
          this.existsRid[rid] = true
          return {
            pid,
            rid,
            匹配度: radishScore(radish),
            keyMatchMode: onkeyMatchMode,
          }
        })
        await window.app.service('radish').intoProject(data)
        this.$message({ type: 'success', message: '操作成功' })
        this.radishes.forEach(dt => {
          dt.checkedRow = false
          if (this.existsRid[dt._id]) {
            dt.disable = true
          }
        })
        this.setDisplayData()
        this.onConfirm && this.onConfirm()
      } catch (error) {
        this.$message.error(error.message)
      }
      this.joinProjectPending = false
    },
    setDisplayData() {
      // console.log('goodSchools',this.goodSchools)
      let radishes = JSON.parse(JSON.stringify(this.radishes))
      if (this.isNoShuangfei) {
        radishes = radishes.filter(r=>{
          return r.本科院校 && this.goodSchools.includes(r.本科院校) && r.硕士院校 && this.goodSchools.includes(r.硕士院校)
        })
      }
      if (this.isXuekuUp) {
        radishes.sort((next, curr) => {
          return !next.disable && next.isXueku && !curr.isXueku ? -1 : 1
        })
      }
      this.displayRadishes = radishes
      this.total = radishes.length
      this.xuekuNum = radishes.filter(r=>r.isXueku).length
      this.grayNum = radishes.filter(r=>r.disable).length
      this.$nextTick(function() {
        this.$refs.radishTable.setDisplay(true)
      })
    },
    toChooseCity(field) {
      const func = val => {
        this.handleSearchChange({ label: field, content: val })
      }
      app.root.$refs.ChooseCity.open(this.searchData[field], func)
    },
  },
}
</script>
<style>
.radish-pop {
  background-color: #fff;
  border: 1px solid #eee;
  padding: 5px;
  border-radius: 4px;
}
.highlight-span {
  color: #f00 !important;
}
.ku-item {
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  position: absolute;
  right: 5px;
  top: 2px;
  color: #409eff;
  background: #fff;
}
.arrow-slider {
  flex: 1;
  display: flex;
  flex: none;
  align-items: center;
  padding-right: 10px
}
.arrow-slider-tags {
  display: inline-block;
  height: 28px;
  overflow: hidden;
  width: 100%;
  position: relative;
}
.arrow-slider-inner {
  white-space: nowrap;
  position: absolute;
  top: 2px;
}
.arrow-slider .el-tag {
  margin-right: 5px;
}
.arrow-slider-arrow {
  height: 28px;
  line-height: 28px;
  width: 20px;
  text-align: center;
  cursor: pointer;
  flex: none;
  background:#e0e7ec;
  color: #409eff;
}
</style>
